import { useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { useCart } from "../contexts/CartContext";
import { db } from "../firebase";

export default function LoadFirestoreCart({ user }) {
  const { setCart } = useCart();

  useEffect(() => {
    async function loadCart() {
      if (!user) return;

      const ref = doc(db, "users", user.uid);
      const snap = await getDoc(ref);

      if (snap.exists()) {
        const data = snap.data();
        console.log("🔥 Loaded Firestore cart:", data.cart);
        setCart(data.cart || []);   // 👈 IMPORTANT
      } else {
        console.log("No cart found for user");
      }
    }

    loadCart();
  }, [user]);

  return null;
}
